import React from "react";
import UFOLoadHold from "@atlaskit/react-ufo/load-hold";

interface UFOSuspenseFallbackProps {
  name: string;
  children?: React.ReactNode;
}

export function UFOSuspenseFallback({ name, children }: UFOSuspenseFallbackProps): React.JSX.Element {
  return <UFOLoadHold name={name}>{children}</UFOLoadHold>;
}
